module.exports = __webpack_public_path__ + "img/4f45c90.webp";